import Pusher from 'pusher-js';

export default function pusher() {
  let pusherData = $('[name=pusher]');
  let pusherAuthRoute = $('[name=pusher_auth_route]').val();

  if (pusherData.length) {
    let pusher = new Pusher(pusherData.val(), {
      cluster: $('[name=pusher_cluster]').val(),
      authEndpoint: pusherAuthRoute,
      disableStats: true,
    });

    listenExportFileChannel(pusher);
  }

  /**
   * Listen export file channel.
   * @param pusher
   */
  function listenExportFileChannel(pusher) {
    let pusherChannelName = $('[name=pusher_channel_name]').val();
    let pusherStartEventName = $('[name=pusher_start_event_name]').val();
    let pusherSuccessEventName = $('[name=pusher_success_event_name]').val();
    let pusherFailEventName = $('[name=pusher_fail_event_name]').val();

    let channel = pusher.subscribe(pusherChannelName);

    channel.bind(pusherStartEventName, (data) => {
      let startToastElement = document.getElementById('exportStartToast');
      let startToast = bootstrap.Toast.getOrCreateInstance(startToastElement);

      startToast.show();

      startToastElement.addEventListener('hidden.bs.toast', function () {
        location.reload();
      });
    });

    channel.bind(pusherSuccessEventName, (data) => {
      let fileName = data.file_path.split('/')[1];

      let successToastElement = document.getElementById('exportSuccessToast');
      let successToast = bootstrap.Toast.getOrCreateInstance(successToastElement);

      let bodyOfToast = successToastElement.getElementsByClassName('toast-body')[0];
      bodyOfToast.innerHTML = bodyOfToast.innerHTML.replace('{fileName}', fileName);

      successToast.show();

      successToastElement.addEventListener('hidden.bs.toast', function () {
        location.reload();
      });
    });

    channel.bind(pusherFailEventName, (data) => {
      let exportTableCode = data.exportFileModel.table_code;
      let exportDateTime = data.exportFileModel.created_at;

      let failToastElement = document.getElementById('exportFailToast');
      let failToast = bootstrap.Toast.getOrCreateInstance(failToastElement);

      let bodyOfToast = failToastElement.getElementsByClassName('toast-body')[0];
      bodyOfToast.innerHTML = bodyOfToast.innerHTML
        .replace('{tableCode}', exportTableCode)
        .replace('{dateTime}', exportDateTime);

      failToast.show();

      failToastElement.addEventListener('hidden.bs.toast', function () {
        location.reload();
      });
    });
  }
}
